import styled from 'styled-components'

export default styled.div`
  margin-right: auto;
  margin-left: auto;
  padding-left: 15px;
  padding-right: 15px;

  @media (min-width: 768px) {
    max-width: 750px;
  }

  @media (min-width: 992px) {
    max-width: 970px;
  }

  @media (min-width: 1200px) {
    max-width: 1170px;
  }

  &.padding-top {
    padding-top: calc(60px + var(--safe-area-top, 0px));
  }
`
